export enum YesNoDialogResult {
  No,
  Yes,
  Close
}
